import { checkListsAPI } from "./api";

export const getCheckListsList = async (params) => {
  try {
    const res = await checkListsAPI.getCheckListsList(params);
    const data = res?.data;
    const total = res?.total_count;
    return { data, total };
  } catch (e) {}
};

export const getWorkSetChecks = async (workSetId) => {
  try {
    const res = await checkListsAPI.getWorkSetChecks({ work_set_id: workSetId });
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const createWorkSetChecks = async (workSetId, checkListIds) => {
  try {
    const res = await checkListsAPI.createWorkSetChecks({
      work_set_id: workSetId,
      check_list_ids: checkListIds
    });
    return res?.data || [];
  } catch (e) {
    return null;
  }
};

export const deleteWorkSetCheck = async (workSetCheckId) => {
  try {
    await checkListsAPI.deleteWorkSetCheck(workSetCheckId);
    return true;
  } catch (e) {
    return false;
  }
};

export const getWorkSets = async () => {
  try {
    const res = await checkListsAPI.getWorkSets();
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const constructivesTableColumns = [
  {
    name: "work_set_name",
    required: true,
    label: "Конструктив",
    align: "left",
    field: "work_set_name",
    sortable: true,
  },
  {
    name: "check_lists_count",
    required: true,
    label: "Чек-листы",
    align: "center",
    field: "check_lists_count",
    sortable: true,
  },
  {
    name: "is_active",
    required: true,
    label: "Активный",
    align: "center",
    field: "is_active",
    sortable: true,
  },
  {
    name: "formula",
    required: true,
    label: "Формула",
    align: "center",
    field: "formula",
    sortable: true,
  },
  {
    name: "actions",
    label: "Действия",
    align: "center",
    field: "actions",
  },
];
